import { parseRes } from './utils/parseRes.js';
import { parseXLSX } from './utils/parseXLSX.js';

export function oanParseHitec(xlsx, res) {
  const variables = parseXLSX(xlsx);
  const meta = parseRes(res);
  return { variables, meta };
}
